import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild } from "@angular/router";
import { select, Store } from "@ngrx/store";
import { AuthenticationStatus, AuthSelector, CoreState, Jurisdiction, JurisdictionSelector } from "@obg/ngx.core";
import { RouteConfig } from "@obg/ngx.router";
import { ignoreNil } from "@obg/rxjs";
import { Observable, of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";

import { HampiService } from "./hampi.service";

@Injectable({
	providedIn: "root",
})
export class HampiGuard implements CanActivateChild, CanActivate {
	constructor(
		private store: Store<CoreState>,
		private hampiService: HampiService
	) {}

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
		return this.store.pipe(
			select(JurisdictionSelector.get),
			ignoreNil(),
			switchMap((jurisdiction) =>
				jurisdiction !== Jurisdiction.Mta
					? of(true)
					: this.store.select(AuthSelector.getAuthenticationStatus).pipe(
							filter((status) => status !== AuthenticationStatus.Pending),
							switchMap((status) =>
								status !== AuthenticationStatus.Authenticated
									? of(true)
									: this.hampiService.isProductAllowed$(
											(route.routeConfig as RouteConfig)?.name,
											true
										)
							)
						)
			)
		);
	}

	canActivateChild(childRoute: ActivatedRouteSnapshot): Observable<boolean> {
		return this.canActivate(childRoute);
	}
}
